module.exports = __webpack_public_path__ + "static/media/singleUser.12468f4c.svg";